module.exports = __webpack_public_path__ + "static/media/lyfestyle_1.42c58d6c.png";